module.exports = __webpack_public_path__ + "img/downLoad.3035ca11.png";